module.exports = __webpack_public_path__ + "img/boy2.f34c693f.jpeg";